import { useLocation } from "react-router-dom";
import { useSettings } from "../lib/settings";
import { WaIcon } from "./WhatsAppButton";

export function FloatingWhatsApp() {
  const { settings } = useSettings();
  const { pathname } = useLocation();
  const number = (settings.whatsapp_number || "").replace(/\D/g, "");
  if (!number || pathname.startsWith("/admin")) return null;
  const text = encodeURIComponent(`Hi ${settings.company_name || "Arnav Enterprises"}, I'd like to know more about your solar solutions.`);
  return (
    <a
      href={`https://wa.me/${number}?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Chat with us on WhatsApp"
      className="hidden md:flex fixed bottom-5 right-5 z-50 group items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5b] text-white rounded-full shadow-[0_8px_30px_rgba(37,211,102,0.45)] pl-3 pr-5 py-3 transition-[background-color,transform] hover:-translate-y-1 wa-pulse"
    >
      <WaIcon className="w-7 h-7" />
      <span className="text-sm font-semibold">Chat with us</span>
    </a>
  );
}
